// Code module — client entry point.
//
// The module's main screen is the code section of the unified project screen, contributed as a project panel
// (rendered by `client/src/pages/projects/ProjectDetailPage.tsx` for organizations that have the module on).
// The workstream tuning summary card is a workstream panel; the tuning page is a route. No navigation entry.
import type {
  ClientModule,
  ClientProjectPanelContribution,
  ClientWorkstreamPanelContribution,
} from '../../../client/src/modules/registry.js';
import { CODE_MODULE_ID, codeManifest } from '../manifest.js';
import { codeRoutes } from './routes.js';

const codeProjectPanels: ClientProjectPanelContribution[] = [
  {
    id: 'code',
    label: 'Code',
    moduleId: CODE_MODULE_ID,
    policy: 'CanAccessProjectCode',
    lazy: () => import('./pages/ProjectCodeTab.js').then((m) => ({ default: m.ProjectCodeTab })),
  },
];

const codeWorkstreamPanels: ClientWorkstreamPanelContribution[] = [
  {
    id: 'code-tuning',
    moduleId: CODE_MODULE_ID,
    lazy: () => import('./components/CodeTuningSummaryCard.js').then((m) => ({ default: m.CodeTuningSummaryCard })),
  },
];

export const codeClientModule: ClientModule = {
  manifest: codeManifest,
  routes: codeRoutes,
  projectPanels: codeProjectPanels,
  workstreamPanels: codeWorkstreamPanels,
};
